import PureKitRegisterSnippet from "snippets/purekit/password-encryption/register";
import PureKitAuthenticateSnippet from "snippets/purekit/password-encryption/authenticate";
import * as React from 'react';
export default {
  PureKitRegisterSnippet,
  PureKitAuthenticateSnippet,
  React
};